<template>
  <basic-container>
      <!-- :search.sync="query"  -->
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="()=>{
            onLoad();
      }"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-top"
          plain
          v-if="permissionList.syncBtn"
          @click="handleSync"
        >同步下发
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
    import {
      add,
      getDetail,
      getList,
      remove,
      update,
      syncCarParkGroup,
      // getCarParkList,
      // getRegionList
      } from "@/api/v4ward/car/carparkgroup";
    import {mapGetters} from "vuex";
export default {
  data() {
    return {
      option: {
            height: 'auto',
            calcHeight: 50,
            tip: false,
            border: true,
            indexLabel:'序号',
            index: true,
            viewBtn: true,
            selection: true,
            columnBtn: false,
            refreshBtn: false,
            delBtn:true,
            searchMenuSpan: 6,
            dialogClickModal:false,
            column: [
              {
                label: "主键",
                prop: "id",
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
                width: 90,
              },
              {
                label: "车场名称",
                prop: "spaceName",
                width: 90,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                search: false,
              }
            ]
      },
    }
  },
  methods:{
    
        rowSave(row, loading, done) {
          console.log('rowSave====================>',row);
          row.carParkStartTime = row.endTimeRange[0];
          row.carParkEndTime = row.endTimeRange[1];
          add(row).then(
            () => {
              loading();
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        },
        rowUpdate(row, index, loading, done) {
          console.log('rowSave====================>',row);
          row.carParkStartTime = row.endTimeRange[0];
          row.carParkEndTime = row.endTimeRange[1];
          update(row).then(
            () => {
              loading();
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        },
        rowDel(row) {
          this.$confirm('确定将选择数据删除?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return remove({ ids: row.id });
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
            });
        },
        handleSync() {
          if (this.selectionList.length === 0) {
            this.$message.warning('请选择至少一条数据');
            return;
          }
          this.$confirm('确定将选择数据同步?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return syncCarParkGroup({ ids: this.ids , parkingLotId:this.query.parkingLotId});
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.$refs.crud.toggleSelection();
            });
        },
        beforeOpen(done, type) {
          let self = this;
              this.regionFlag = false;
              this.parkingLotFlag = false;
          if (['edit', 'view'].includes(type)) {
              this.parkingLotFlag = true;
            if (['view'].includes(type)) {
              this.regionFlag = true;
            }
            getDetail({ id: this.form.id }).then(({ data }) => {
              this.form = data;
              let startArr = self.form.carParkStartTime.split('T');
              let endArr = self.form.carParkEndTime.split('T');
              this.form.endTimeRange = [startArr[0],endArr[0]];
              console.log('this.edit.form>>>>>', this.form);
            });
          }else {
            let self = this;
            this.form.parkingLotId = this.query.parkingLotId;
            this.form = Object.assign({},self.form,{
              parkingLotId:self.query.parkingLotId
            })
            console.log("beforeOpen==============>",type);
          }
          done();
        },
        searchReset() {
          console.log("========query==========>",this.query);
          let parkingLotId = this.query.parkingLotId;
          this.query = Object.assign({},this.query,{
            parkingLotId: parkingLotId,
            regionId: '',
            startTime: '',
            endTime: '',
            responsiblePersonName:'',
            responsiblePersonPhone:'',
            endTimeRange:[],
            plateNumbers:''
          });
          this.firstDisplayFlag = true;
          this.onLoad();
        },
        searchChange(params, done) {
          console.log("params==============>",params);
          let self = this;
          self.query = {
            parkingLotId: self.query.parkingLotId,
            regionId: self.query.regionId,
          }
          this.query = Object.assign({},this.query,params);
          this.page.currentPage = 1;
          console.log("this.query========>",this.query);
          if(params.endTimeRange&&params.endTimeRange.length>0){
            this.query.startTime = this.query.endTimeRange[0];
            this.query.endTime = this.query.endTimeRange[1];
          }

          this.onLoad();
          done();
        },
        selectionChange(list) {
          this.selectionList = list;
        },
        selectionClear() {
          this.selectionList = [];
          this.$refs.crud.toggleSelection();
        },
        currentChange(currentPage) {
          this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
          this.page.pageSize = pageSize;
        },
        onLoad(page) {
          let self = this;
          page = page || this.page;
          this.loading = true;
          //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
          if (!this.query.parkingLotId ) {
            console.log('this.query.parkingLotId===========>',this.query.parkingLotId);
            this.query.parkingLotId = this.tempCarParkId;
          }
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="车场名称"]');
              ent.value = this.getCarParkNameById(self.query.parkingLotId);
              this.tempCarParkId = this.query.parkingLotId;
              //关闭默认显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          });
        }
  },
}
</script>

<style>

</style>